import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MDTypography from "components/MDTypography";

const lightColors = { "Aberto": "rgba(241,222,114,0.7)", "Fechado": "rgba(154,245,177,0.7)", "N/A": "rgba(147,150,148,0.7)" }

export default function ReportTable({ data }) {
    const datasets = data?.datasets || []

    return (
        <TableContainer component={Card}>
            <div style={{ display: "flex", gap: "16px", padding: "12px", borderBottom: "1px solid #e0e0e0" }}>
                {Object.entries(lightColors).map(([label, color]) => (
                    <div key={label} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <div style={{ width: 44, height: 14, borderRadius: 3, backgroundColor: color }} />
                        <MDTypography variant="caption">{label}</MDTypography>
                    </div>
                ))}
            </div>
            <Table size="small" sx={{ minWidth: 650 }}>
                <TableBody>
                    {data?.labels
                        ?.map((label, index) => {
                            const values = datasets.map(ds => ds.data?.[index] || 0)
                            const total = values.reduce((a, b) => a + b, 0)
                            return { label, values, total }
                        })
                        ?.sort((a, b) => b.total - a.total)
                        ?.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ py: 0.5, px: 1 }}><MDTypography variant="caption" fontWeight="regular" color="black">{row.label}</MDTypography></TableCell>
                                {row.values.map((v, i) => (
                                    <TableCell key={i} align="center" sx={{ py: 0.5, px: 1, backgroundColor: lightColors[datasets[i]?.label] || "inherit" }}>
                                        <MDTypography variant="caption" color="black">{v}</MDTypography>
                                    </TableCell>
                                ))}
                                <TableCell align="center" sx={{ py: 0.5, px: 1 }}><MDTypography variant="caption" color="black">{row.total}</MDTypography></TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
